import React from "react"

import { ApiResponse } from "shared/types/ApiResponse"

import { ProjectFormData } from "features/project-management/types/ProjectFormData"
import { ProjectModel } from "features/project-management/types/ProjectModel"

import { ProjectPageProjectSidebarView } from "./ProjectPageProjectSidebarView"
import { useProjectPageProjectSidebarViewModel } from "./hooks/useProjectPageProjectSidebarViewModel"

export interface ProjectPageProjectSidebarModel {
  projectID: string
  model: ProjectModel

  onSubmit?: (formData: ProjectFormData) => Promise<ApiResponse<unknown>> | void

  hideControls?: boolean

  isEditing: boolean
  enterEditing: () => void
  exitEditing: () => void
  sidebarActiveTab: string | null
  setSidebarActiveTab: (tab: string | null) => void
}

export interface ProjectPageProjectSidebarProps
  extends ProjectPageProjectSidebarModel {
  id: string
}

export const ProjectPageProjectSidebar = React.memo(
  (props: ProjectPageProjectSidebarProps) => (
    <ProjectPageProjectSidebarView
      {...useProjectPageProjectSidebarViewModel(props)}
    />
  )
)
